import { uploadTgCloudStorage, downloadTgCloudStorage, clearTgCloudStorage } from '../utils/telegramCloudStorage';

export interface QssWalletAddress {
    network: string
    name: string
    address: string
}

const useQssWalletAddress = () => {
    
    const KEY_QSS_WALLETADDRESS = `qss_walletaddress` // 지갑주소 저장 키

    /**
     * 텔레그램 클라우트 스토리지 키
     * @param key 
     * @returns 
     */
    const getTelegramStorageKey = async (addKey: string) => {
        const key = `${KEY_QSS_WALLETADDRESS}_${addKey}`
        console.log(`getTelegramStorageKey key`, key)
        return key;
    }

    /**
     * QSS 지갑주소 중복 확인
     * @param network 
     * @param walletAddress 
     * @returns 
     */
    const checkOverlapQssWalletAddress = async (network: string, walletAddress: string) => {
        try {
            // tg cloud 에 저장된 지갑주소 가져오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)
            
            if(null == qssValue || '' === qssValue) {
                // 저장된 지갑주소 데이터가 없을 경우 리턴
                console.log(`checkOverlapQssWalletAddress qssValue is empty`)
                return false
            }

            const parsedData = JSON.parse(qssValue.toString());
            console.log(`checkOverlapQssWalletAddress parsedData`, parsedData)

            // json 배열 형태로 변경
            const walletJsonArray = parsedData.mnemonicHashList
            console.log(`checkOverlapQssMnemonicHash - walletJsonArray`, walletJsonArray)

            // 중복된 지갑주소가 있는지 확인
            if( false === await isWalletAddressDuplicate(walletJsonArray, network, walletAddress) ) {
                return false
            }

            return true
        } catch (error) {
            console.log(`Error checkOverlapQssWalletAddress : `, error)
        }

        return false
    };

    /**
     * 이전에 저장된 QSS 지갑주소 데이터 있는지 확인
     * @param network 
     * @returns boolean
     */
    const checkEmptyQssWalletAddress = async (network:string) => {
        try {
            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)
            console.log(`checkEmptyQssWalletAddress qssValue`, qssValue)

            if(null == qssValue || '' === qssValue) {
                return true;
            }
        } catch(error) {
            console.warn('Error checkEmptyQssWalletAddress', error);
        }

        return false;
    };

    /**
     * qss에 저장된 지갑주소 가져오기
     * @param network 
     * @returns 
     */
    const getQssWalletAddress = async (network:string) => {
        let result = false;
        let value = null;

        try {
            // 기존에 qss 저장된 지갑주소 정보 가져오기
            const key = await getTelegramStorageKey(network);
            console.log(`getQssWalletAddress - key : ${key}`)
            const qssValue = await downloadTgCloudStorage(key)

            if(null == qssValue || '' === qssValue) {
                // 데이터가 없을 경우 리턴하고 종료
                console.log(`getQssWalletAddress qssValue is empty`)
                result = true;
                return {result, value};
            } 
            
            // json parse 처리
            const parsedData = JSON.parse(qssValue.toString());
            // console.log(`getQssWalletAddress parsedData : `, parsedData)

            // 지갑주소 배열 리턴
            result = true
            value = parsedData
            return {result, value};
        } catch (error) {
            // 복호화기 실패하면 리턴하고 종료
            console.warn('Error getQssWalletAddress', error);
        }

        return {result, value};
    };

    /**
     * qss에 지갑주소 저장
     * @param networkName : 네트워크(체인) 이름
     * @param name : 지갑주소 이름
     * @param newWalletAddress : 추가할 지갑주소
     * @returns 
     */
    const addQssWalletAddress = async (networkName:string, name: string, newWalletAddress: string) => {
        try {
            if( null == networkName || '' === networkName) {
                console.log(`addQssMnemonic networkName 값 오류`, networkName)
                return false
            }
            else if( null == name || '' === name) {
                console.log(`addQssMnemonic 추가할 니모닉 이름 값 오류`, name)
                return false
            } else if(null == newWalletAddress || '' === newWalletAddress) {
                console.log(`addQssMnemonic 추가할 지갑주소 값 오류`, newWalletAddress)
                return false
            }

            // 기존에 qss 저장된 데이터 불러오기
            const key = await getTelegramStorageKey(networkName);
            console.log(`addQssWalletAddress - key : ${key}`)
            const qssValue = await downloadTgCloudStorage(key)
            console.log(`addQssWalletAddress - 시작 qssValue`, qssValue)

            if(null == qssValue || '' === qssValue) {
                // 데이터 없을 경우 새로 생성해서 추가
                const qssWalletArray: QssWalletAddress[] = [];

                // 이름-지갑주소
                const qssWallet:QssWalletAddress = {
                    "network": networkName,
                    "name": name,
                    "address": newWalletAddress
                }
                qssWalletArray.push(qssWallet)

                // 이름-지갑주소 json stringfy 처리
                const stringifyArray = JSON.stringify(qssWalletArray)
                console.log(`addQssWalletAddress 신규- stringifyArray : `, qssWalletArray)

                // structQssMnemonic 데이터 tg cloud로 저장
                const uploadResult = await uploadTgCloudStorage(key, stringifyArray)
                console.log(`addQssWalletAddress 신규- uploadTgCloudStorage 결과 : `, uploadResult)

                return uploadResult
            } else {
                // 데이터 있을 경우

                // json 배열 형태로 변경
                const parsedData = JSON.parse(qssValue.toString());
                console.log(`addQssWalletAddress - 추가 parsedData`, parsedData)

                const qssWalletArray = parsedData

                if(false === await isWalletAddressDuplicate(qssWalletArray, networkName, newWalletAddress))
                {
                    // 중복 없음 이름-지갑주소 추가
                    const qssWallet:QssWalletAddress = {
                        "network": networkName,
                        "name": name,
                        "address": newWalletAddress
                    }
                    qssWalletArray.push(qssWallet)
                } else {
                    // 중복이면 추가 저장하지 않고 리턴
                    console.log(`addQssWalletAddress - 추가 중복 지갑주소 있음 :${networkName}|${newWalletAddress}`)
                    return false;
                }

                // 니모닉 json 배열 생성. stringfy 처리
                const strQssWallet = JSON.stringify(qssWalletArray)
                console.log(`addQssWalletAddress 추가 - strQssWallet : `, strQssWallet)

                const uploadResult = await uploadTgCloudStorage(key, strQssWallet)
                console.log(`addQssWalletAddress 추가 - uploadTgCloudStorage 결과 : `, uploadResult)

                return uploadResult
            }
        } catch (error) {
            console.error('fail addQssWalletAddress', error);
        }      
        return false;
    };

    /**
     * qSS의 지정한 지갑주소 삭제
     * @param password 
     * @param network : 블록체인 네트워크
     * @param delAddress : 삭제할 지갑주소
     * @returns 
     */
    const removeQssWalletAddress = async (network:string, delAddress: string) => {
        try { 
            if(null == delAddress || '' === delAddress) {
                console.log(`removeQssWalletAddress 삭제할 지갑주소 오류`, delAddress)
                return false
            }

            // 기존에 qss 저장된 지갑주소 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)

            if(null == qssValue || '' === qssValue) {
                // 저장된 데이터가 없으면 리턴
                console.log(`removeQssWalletAddress qssValue is empty`)
                return false;
            }

            const parsedData = JSON.parse(qssValue.toString());
            console.log(`removeQssWalletAddress 삭제 전 parsedData`, parsedData)

            // 배열에 저장
            const qssWalletArray: QssWalletAddress[] = parsedData;
            console.log(`removeQssWalletAddress 삭제 전 qssWalletArray`, qssWalletArray)

            // 일치하는 니모닉 있는지 확인
            if(true === await isWalletAddressDuplicate(qssWalletArray, network, delAddress)) {
                // 삭제할 네트워크-지갑주소와 일치하지 않는 리스트 추출
                const updatedWalletArray = qssWalletArray.filter(item => !(item.address === delAddress && item.network === network))
                console.log(`removeQssWalletAddress 삭제후 업데이트 된 지갑주소 배열`, updatedWalletArray)

                // 갱신된 지갑주소 배열 json stringify
                const stringifyArray = JSON.stringify(updatedWalletArray)
                console.log(`removeQssWalletAddress 삭제 후 stringifyArray`, stringifyArray)

                const uploadResult = await uploadTgCloudStorage(key, stringifyArray)
                console.log(`removeQssWalletAddress 삭제된 배열 tg 클라우드 업데이트 결과`, uploadResult)

                return uploadResult
            } else {
                console.log(`removeQssWalletAddress 삭제할 지갑주소 없음`)
            }
        } catch(error){
            console.warn('Error removeQssWalletAddress', error);
        }

        return false;
    }

    /**
     * 지정한 QSS 지갑주소 이름 변경
     * @param newName 
     * @param index 
     * @param network 
     * @returns 
     */
    const editNameQssWalletAddress = async (newName: string, index:number, network:string) => {
        if( null == newName || '' === newName) {
            console.log(`editNameQssWalletAddress 변경할 니모닉 이름 값 오류`, newName)
            return false
        }
        
        try {
            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)
            console.log(`editNameQssWalletAddress - 시작 qssValue`, qssValue)

            if(null == qssValue || '' === qssValue) {
                // 저장된 데이터가 없으면 리턴
                console.log(`editNameQssWalletAddress qssValue is empty`)
                return false;
            }

            const parsedData = JSON.parse(qssValue.toString());
            console.log(`editNameQssWalletAddress 지갑주소 이름 변경 전 parsedData`, parsedData)

            // QSS 의 지갑주소 데이터 json 배열로 변경
            const walletJsonArray: QssWalletAddress[] = parsedData;
            console.log(`editNameQssMnemonic 지갑주소 이름 변경 전 walletJsonArray`, walletJsonArray)

            if (index >= 0 && index < walletJsonArray.length) {
                walletJsonArray[index].name = newName; // name 값을 변경
            } else {
                console.error("잘못된 인덱스번호. 지갑이름 변경하지 않음");
                return false;
            }

            // 변경된 니모닉해시 데이터 parsedData 에 저장
            const stringJsonArray = JSON.stringify(walletJsonArray)
            console.log(`editNameQssMnemonic 지갑주소 이름 변경 후 - stringJsonArray : `, stringJsonArray)

            const uploadResult = await uploadTgCloudStorage(key, stringJsonArray)
            console.log(`editNameQssMnemonic 이름 변경된 니모닉 배열 클라우드 업데이트 결과`, uploadResult)

            return uploadResult
        } catch(error) {
            console.warn('Error editNameQssWalletAddress', error);
        }

        return false;
    
    }

    /**
     * qss에 저장된 지갑주소 clear
     * @param network 
     * @returns 
     */
    const clearQssWalletAddress = async (network:string) => {
        let result = false;
        let value = null;

        try {
            const key = await getTelegramStorageKey(network);
            const clearResult = await clearTgCloudStorage(key)
            console.log(`clearQssWalletAddress - ${key} clearResult : `, clearResult)
            if(true === clearResult) {
                result = true;
            }
        } catch (error) {
            console.error('Error clearQssWalletAddress', error);
        }

        return {result, value};
    };
    

    
    // 지갑주소 배열에 해시값 중복 여부 확인 함수
    const isWalletAddressDuplicate = (array: QssWalletAddress[], network:string, newItem: string): boolean => {
        return array.some(item => (item.address === newItem && item.network === network))
    }

    // 외부 export할 함수 이름 설정
    return {
        checkOverlapQssWalletAddress,
        checkEmptyQssWalletAddress,
        getQssWalletAddress,
        addQssWalletAddress,
        removeQssWalletAddress,
        editNameQssWalletAddress,
        clearQssWalletAddress
    };

}

export default useQssWalletAddress;